import journeyrewardbg from "../../assets/images/journeyrewardbg2.png";
import journeyrewardobject from "../../assets/images/journeyrewardobject2.png";
import journeyrewardobject2 from "../../assets/images/journeyrewardobject22.png";

interface AlreadyClaimedRewardPopupProps {
  rewardAmount: number;
  onClose?: () => void;
}

const AlreadyClaimedRewardPopup = ({
  rewardAmount,
  onClose,
}: AlreadyClaimedRewardPopupProps) => {
  const rewardInGB = rewardAmount / 1000;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/70" onClick={onClose} />

      <div
        className="relative bg-gradient-to-b rounded-[36px] max-w-[320px] shadow-2xl max-w-md w-full overflow-hidden z-10 border-[0.5px] border-white/20"
        style={{
          backgroundImage: `url(${journeyrewardbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center -20px",
        }}
      >
        <div className="flex flex-col items-center text-center relative z-10">
          <div className="w-full relative overflow-hidden">
            <div className="w-full h-full grid grid-cols-1 grid-rows-1 justify-items-center items-center justify-center p-2 gap-2">
              <img
                src={journeyrewardobject2}
                alt="kazan"
                className="w-32 object-contain col-span-full h-8"
              />
              <img
                src={journeyrewardobject}
                alt="chest"
                className="w-36 object-contain col-span-full"
              />
            </div>
          </div>

          <div className="px-2 py-2 w-full flex flex-col items-center">
            <h2 className="text-xl font-medium text-white">
              Ödülünü zaten aldın!
            </h2>

            <p className="text-base mx-6 text-white/90 mb-4">
              Daha fazla kazanmak için şifreni girerek devam et.
            </p>

            <div className="w-full flex flex-col gap-2">
              <button
                onClick={onClose}
                className="w-full bg-[#0088FF] text-white rounded-full py-4 px-6 font-normal text-base hover:bg-[#0088FF]/90 transition-colors flex items-center justify-center gap-2"
              >
                Devam Et
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlreadyClaimedRewardPopup;
